import { auditsScenarios } from './steps'
import { auditsTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const auditsOnboarding: IOnboardingModule = {
  scenarios: auditsScenarios,
  texts: auditsTexts,
  conditions: {},
}
